export const SET_APHORISMS = 'SET_APHORISMS';
export const CREATE_APHORISM = 'CREATE_APHORISM';
export const DELETE_APHORISM = 'DELETE_APHORISM';